import { Pergunta } from './pergunta';

export class CategoriaPergunta {
    public id: number;
    public denominacao: string;
    public questionario: number;

    public perguntas: Pergunta[];
}
